import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography as MUITypography } from '@material-ui/core';
import type { TypographyProps } from '@material-ui/core/Typography';
import classNames from 'classnames';

import { removeKlpStyles } from '../Theme';
import type { KlpStyled } from '../Theme/KlpStyles';
import { useKlpStyles } from '../Theme/useKlpStyles';

interface IOwnProps {
    translation?: string;
    translationOptions?: object;
}

export type ITypographyProps = IOwnProps & TypographyProps & KlpStyled;

export const Typography = React.forwardRef<HTMLSpanElement, ITypographyProps>(
    (
        { children, className, translation, translationOptions, ...restProps },
        ref,
    ) => {
        const classes = useKlpStyles(restProps);
        const { t } = useTranslation();
        return (
            <MUITypography
                ref={ref}
                className={classNames(classes.klpStyles, className)}
                {...removeKlpStyles(restProps)}
            >
                {translation ? t(translation, translationOptions) : children}
            </MUITypography>
        );
    },
);

Typography.displayName = 'Typography';
